import { Quaternion } from '@babylonjs/core/Maths';
import { SolidParticle } from '@babylonjs/core/Particles/solidParticle';
import { CircularPatternFeature } from '@kb3d/models/classes/features/circular-pattern-feature';
import { Token } from '@kb3d/models/classes/token';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { PatternRenderer } from './pattern';
import { CircularPatternGeometryProcessor } from './geometry-processor/circular-pattern-geometry';

export class CircularPatternRenderer extends PatternRenderer {
    modelToken = Token.CircularPatternFeature;
    processor = new CircularPatternGeometryProcessor(this.scene);
}
